import {
  Settings24Regular,
  Person24Regular,
  Navigation24Regular,
  SignOut20Regular,
} from '@fluentui/react-icons';
import { useState } from 'react';
import { GlobalSearchBar } from './GlobalSearchBar';

interface CommandBarProps {
  onOpenSettings: () => void;
  onToggleMobileMenu: () => void;
  onNavigate: (item: string) => void;
  onLogout?: () => void;
  userLabel?: string;
  /** Mostra o botão de Definições. Fora dele, quem não tem a feature nem sequer o vê. */
  canOpenSettings?: boolean;
}

export function CommandBar({
  onOpenSettings,
  onToggleMobileMenu,
  onNavigate,
  onLogout,
  userLabel,
  canOpenSettings = false,
}: CommandBarProps) {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const handleNavigate = (target: string) => {
    onNavigate(target);
    setIsUserMenuOpen(false);
  };

  const handleLogout = () => {
    onLogout?.();
    setIsUserMenuOpen(false);
  };

  return (
    <header className="flex items-center justify-between h-12 px-3 md:px-6 bg-card border-b border-border">
      {/* Mobile Menu Button + Global Search */}
      <div className="flex items-center flex-1 gap-2">
        <button
          onClick={onToggleMobileMenu}
          className="p-2 rounded hover:bg-accent text-foreground transition-colors md:hidden min-w-[44px] min-h-[44px] flex items-center justify-center"
          aria-label="Open menu"
          style={{ borderRadius: 'var(--radius-button)' }}
        >
          <Navigation24Regular className="w-6 h-6" />
        </button>
        <GlobalSearchBar />
      </div>

      {/* Actions */}
      <div className="flex items-center gap-1 md:gap-2 relative">
        {/* Settings button — só para quem tem acesso às Definições */}
        {canOpenSettings && (
          <button
            onClick={onOpenSettings}
            className="p-2 rounded hover:bg-accent text-foreground transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
            aria-label="Settings"
            style={{ borderRadius: 'var(--radius-button)' }}
          >
            <Settings24Regular className="w-6 h-6" />
          </button>
        )}

        {/* User Profile - Compact on mobile */}
        <div className="ml-1 md:ml-2 pl-1 md:pl-2 border-l border-border relative">
          <button
            className="flex items-center gap-2 p-2 rounded hover:bg-accent text-foreground transition-colors min-h-[44px]"
            aria-label="User profile"
            style={{ borderRadius: 'var(--radius-button)' }}
            onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
          >
            <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
              <Person24Regular className="w-5 h-5 text-primary-foreground" />
            </div>
            <span className="text-secondary-text hidden lg:inline">
              {userLabel ?? "Utilizador"}
            </span>
          </button>

          {/* User Menu Dropdown */}
          {isUserMenuOpen && (
            <>
              {/* Backdrop */}
              <div 
                className="fixed inset-0 z-40"
                onClick={() => setIsUserMenuOpen(false)}
              />

              {/* Dropdown Content */}
              <div 
                className="absolute right-0 top-full mt-2 bg-card border border-border shadow-lg z-50 min-w-[200px]"
                style={{ borderRadius: 'var(--radius-card)' }}
              >
                <div className="py-2">
                  <button
                    onClick={() => handleNavigate("perfil")}
                    className="w-full px-4 py-2.5 text-left hover:bg-accent transition-colors text-foreground flex items-center gap-2"
                    style={{ fontSize: 'var(--text-base)' }}
                  >
                    <Person24Regular className="w-5 h-5" />
                    O Meu Perfil
                  </button>
                  <div className="h-px bg-border my-2" />
                  <button
                    onClick={handleLogout}
                    className="w-full px-4 py-2.5 text-left hover:bg-accent transition-colors text-foreground flex items-center gap-2"
                    style={{ fontSize: 'var(--text-base)' }}
                  >
                    <SignOut20Regular className="w-5 h-5" />
                    Terminar sessão
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
